@import "@/scss/use-bootstrap-mixins";

.desktopOption {
  background-color: #f0f0f0 !important;
}

.deal_option {
  padding: 0 !important;

  .deal_banner {
    padding: 12px 12px 0px 12px;

    .title {
      text-align: center !important;
      display: block !important;
      font-weight: 700 !important;
      font-size: 16px !important;
    }
  }

  .deal_copy {
    padding: 0 10px 10px 10px;

    @include media-breakpoint-up(md) {
      padding: 0 10px 20px 10px;
    }
  }
}

.wizard_option {
  .option_content {
    padding: 8px 12px !important;

    @include media-breakpoint-up(lg) {
      padding: 14px !important;
    }

    .icon {
      display: flex !important;
    }

    .copy {
      margin-left: 4px !important;
      max-height: initial !important;
      display: flex;
      flex-direction: column;
      .header {
        padding-top: 4px !important;
        line-height: 12px !important;
      }
    }
  }

  .radio_wrapper {
    display: none !important;
  }
}

.options {
  background-color: #fff;
  border-radius: 14px;
  color: #000;
  max-height: none;

  &:hover {
    cursor: pointer;
  }

  .option_content {
    display: flex;
    align-items: center;
    padding: 8px;
    gap: 8px;

    @include media-breakpoint-up(md) {
      padding: 20px 10px 20px 10px;
    }
  }

  .deal_option_content {
    padding: 8px;

    @include media-breakpoint-up(md) {
      padding: 20px 10px;
    }
  }

  &:last-child {
    margin-bottom: 24px;
  }

  &:not(:last-child) {
    margin-bottom: 12px;
  }

  .icon {
    width: 30px;
    text-align: center;
    display: none;
    font-size: 26px;
    color: $primaryOnBackground;

    @media (min-width: 347px) {
      display: block;
    }

    @include media-breakpoint-up(md) {
      width: 45px;
    }

    svg {
      height: 1em;
    }
  }

  .copy {
    max-height: none;
    justify-content: center;
    display: flex;
    flex-direction: column;

    @include media-breakpoint-up(sm) {
      max-height: 33px;
    }

    .header {
      margin: 0 !important;
      font-size: 14px !important;
      font-weight: 500 !important;
      line-height: 22px !important;

      @include media-breakpoint-up(sm) {
        font-size: 20px !important;
      }
    }
    .label {
      margin: 0 !important;
      font-weight: 500 !important;
      font-size: 12px !important;
    }
  }

  .descriptor_upsell_label {
    margin: 0 !important;
    font-weight: 500 !important;
    font-size: 12px !important;
    padding: 0px 10px 8px 10px;
    display: block;

    @include media-breakpoint-up(md) {
      padding: 4px 10px 10px 10px;
    }
  }

  .price_container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    margin-left: auto;
    max-width: 165px;
    flex-grow: 1;
    flex-shrink: 0;
  }

  .price {
    display: flex;
    flex-grow: 1;
    justify-content: flex-end;
    align-items: center;
    white-space: nowrap;
    margin-right: 8px;

    .display {
      font-size: 16px !important;
      margin: 0 !important;
      font-weight: 500 !important;

      @include media-breakpoint-up(md) {
        font-size: 18px !important;
      }
    }
  }

  .radio_wrapper {
    display: flex;
    align-items: center;
  }

  .radio[type="checkbox"] {
    -webkit-appearance: none;
    appearance: none;
    width: 25px !important;
    height: 25px !important;
    border-radius: 12.5px;
    outline: none;
    cursor: pointer;
    border: 2px solid #888;

    &:checked {
      background-color: #fff;
      border: 7px solid $primary;
    }
  }

  .deal_copy {
    width: 100%;
    padding: 0;
  }
}

.map {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;

  .first {
    display: flex;
    gap: 10px;

    .opt_in {
      display: flex;
      gap: 12px;
      align-items: center;

      .custom_checkbox {
        position: relative;
        min-width: 21px;
        min-height: 21px;

        .label {
          background-color: #fff;
          width: 21px;
          height: 21px;
          border-radius: 11px;
          cursor: pointer;
          position: absolute;
          border: 1px solid $primaryOnBackground;

          &:after {
            display: initial !important;
            border: 2px solid #fff;
            border-top: none;
            border-right: none;
            content: "";
            height: 6px;
            left: 4px;
            opacity: 0;
            position: absolute;
            top: 6px;
            transform: rotate(-45deg);
            width: 11px;
          }
        }

        input[type="checkbox"] {
          display: none;

          &:checked + label {
            background-color: $primaryOnBackground;
            border-color: $primaryOnBackground;

            &:after {
              opacity: 1;
            }
          }
        }
      }

      .upsell_description {
        display: flex;
        gap: 4px;
        align-items: center;

        .name {
          font-size: 15px;
          display: block;
          font-weight: 400 !important;
        }

        .size {
          font-weight: 700 !important;
          font-size: 12px;
          display: block;
        }
      }
    }
  }

  .last {
    .price {
      color: #000;
      text-align: right;
      font-size: 16px !important;
      font-weight: 600 !important;
    }
  }
}
